import React from 'react';
import { connect } from 'react-redux';

class SpecialItemInstructions extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="choice-addon-wrapper special">
                <textarea 
                    value={this.props.value}
                    className="textarea w-input"
                    onChange={this.props.onChangeText}
                    placeholder={this.props.placeholder}
                />
            </div>
        );
    }
};

export default connect()(SpecialItemInstructions);